import { Dropdown, MenuProps } from "antd";
import {
  UserOutlined,
  CustomerServiceOutlined,
  CreditCardOutlined,
  TagsOutlined,
} from "@ant-design/icons";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as MenuIcon } from "../../../../assets/images/icons/menu.svg";
import { isSuperAdmin } from "../../../../utils/permissions";

type Props = {
  user: any;
  canSeeSubscription?: boolean;
  unpaidCount?: number;
};
const UserMenu: React.FC<Props> = ({ user, canSeeSubscription, unpaidCount = 0 }) => {
  const userDetails = user && JSON.parse(user);
  const { t } = useTranslation();
  const navigation = useNavigate();

  const items: MenuProps["items"] = [
    {
      label: (
        <div>
          <div className="userProfile">
            {" "}
            {t("Welcome")} {userDetails?.firstName}
          </div>
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div
          className="userMenuItem"
          onClick={() => {
            navigation(`users/${userDetails?.id}`);
          }}
        >
          {t("User Profile")}
        </div>
      ),
      key: "1",
      icon: <UserOutlined />,
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          className="userMenuItem"
          onClick={() => {
            navigation("support");
          }}
        >
          {t("Support")}
        </div>
      ),
      key: "support",
      icon: <CustomerServiceOutlined />,
    },
    // Subscription — controlled by permission
    ...(canSeeSubscription
      ? [
          {
            label: (
              <div
                className="userMenuItem"
                onClick={() => navigation("/subscription")}
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}
              >
                <span>{t("Subscription")}</span>
                {unpaidCount > 0 && (
                  <span style={{
                    background: "#ff385c", color: "#fff",
                    borderRadius: "999px", fontSize: 11,
                    padding: "1px 7px", fontWeight: 700,
                  }}>
                    {unpaidCount}
                  </span>
                )}
              </div>
            ),
            key: "subscription",
            icon: <CreditCardOutlined style={{ color: unpaidCount > 0 ? "#ff385c" : undefined }} />,
          },
        ]
      : []),
    // Super admin-only items
    ...(isSuperAdmin(userDetails?.roles)
      ? [
          {
            label: (
              <div
                className="userMenuItem"
                onClick={() => {
                  navigation("admin/subscriptions");
                }}
              >
                {t("Subscriptions")}
              </div>
            ),
            key: "subscriptions",
            icon: <CreditCardOutlined />,
          },
          {
            label: (
              <div
                className="userMenuItem"
                onClick={() => {
                  navigation("admin/plans");
                }}
              >
                {t("Plans")}
              </div>
            ),
            key: "plans",
            icon: <TagsOutlined />,
          },
        ]
      : []),
    {
      type: "divider",
    },
    {
      label: (
        <div
          className="userMenuItem"
          onClick={() => {
            navigation("/login");
            localStorage.removeItem("user");
          }}
        >
          {t("Logout")}
        </div>
      ),
      key: "2",
    },
  ];
  return (
    <Dropdown
      overlayClassName={"userMenuContainer"}
      menu={{ items }}
      trigger={["click"]}
    >
      <div className="userMenu">
        {/* <span className="username">
          {userDetails?.firstName?.charAt(0)}. {userDetails?.lastName}
        </span> */}
        <MenuIcon className="userMenuIcon" />
        {/* <Avatar size={32} icon={<UserOutlined />} /> */}
      </div>
    </Dropdown>
  );
};

export default UserMenu;
